/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type UpdateTaskInput = {
    ids?: Array<string | null> | null | undefined;
    projectId?: string | null | undefined;
    projectGroupId?: string | null | undefined;
    parentId?: string | null | undefined;
    phaseId?: string | null | undefined;
    aboveTaskId?: string | null | undefined;
    aboveFavouredTaskId?: string | null | undefined;
    name?: string | null | undefined;
    description?: string | null | undefined;
    estimateLow?: number | null | undefined;
    estimateHigh?: number | null | undefined;
    forecast?: number | null | undefined;
    timeLeft?: number | null | undefined;
    startYear?: number | null | undefined;
    startMonth?: number | null | undefined;
    startDay?: number | null | undefined;
    deadlineYear?: number | null | undefined;
    deadlineMonth?: number | null | undefined;
    deadlineDay?: number | null | undefined;
    roleId?: string | null | undefined;
    assignedPersons?: Array<string | null> | null | undefined;
    unassignAllPersons?: boolean | null | undefined;
    assignedPersonToAdd?: string | null | undefined;
    followers?: Array<string | null> | null | undefined;
    removeAllFollowers?: boolean | null | undefined;
    labels?: Array<string | null> | null | undefined;
    clearAllLabels?: boolean | null | undefined;
    sprintId?: string | null | undefined;
    projectGroupSprintId?: string | null | undefined;
    statusColumnId?: string | null | undefined;
    statusColumnV2Id?: string | null | undefined;
    projectGroupStatusColumnId?: number | null | undefined;
    coverFileId?: string | null | undefined;
    blocked?: boolean | null | undefined;
    bug?: boolean | null | undefined;
    approved?: boolean | null | undefined;
    billable?: boolean | null | undefined;
    repeatingTaskId?: string | null | undefined;
    unassignedTaskId?: string | null | undefined;
    previousProjectId?: string | null | undefined;
    unassignPersonFromTask?: Array<UnassignPersonFromTask | null> | null | undefined;
    remaining?: number | null | undefined;
    highPriority?: boolean | null | undefined;
    ownerId?: string | null | undefined;
    favoured?: boolean | null | undefined;
    favouredSortOrder?: string | null | undefined;
    parentTaskId?: string | null | undefined;
    previousParentTaskId?: string | null | undefined;
    isBulkContext?: boolean | null | undefined;
    validateDependencies?: boolean | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type UnassignPersonFromTask = {
    taskId: string;
    personIds?: Array<string | null> | null | undefined;
};
export type favoriteTaskMutationVariables = {
    input: UpdateTaskInput;
};
export type favoriteTaskMutationResponse = {
    readonly updateTask: {
        readonly taskEdge: {
            readonly node: {
                readonly id: string;
                readonly favoured: boolean | null;
                readonly favouredSortOrder: string | null;
                readonly " $fragmentRefs": FragmentRefs<"DraggableCard_task">;
            } | null;
        } | null;
        readonly updatedTasksIds: ReadonlyArray<string | null> | null;
        readonly viewer: {
            readonly favouredTasksCount: number | null;
        } | null;
    } | null;
};
export type favoriteTaskMutation = {
    readonly response: favoriteTaskMutationResponse;
    readonly variables: favoriteTaskMutationVariables;
};



/*
mutation favoriteTaskMutation(
  $input: UpdateTaskInput!
) {
  updateTask(input: $input) {
    taskEdge {
      node {
        id
        favoured
        favouredSortOrder
        ...DraggableCard_task
      }
    }
    updatedTasksIds
    viewer {
      favouredTasksCount
      id
    }
  }
}

fragment DeprecatedProjectIndicatorJS_project on ProjectType {
  name
  companyProjectId
  customProjectId
  projectColor
}

fragment DraggableCard_task on Task {
  id
  billable
  latestUiUpdateAt
  description
  timeLeft
  progress
  favouredSortOrder
  estimateForecastMinutes
  totalMinutesRegistered
  companyTaskId
  readOnly {
    isReadOnly
    id
  }
  userCanDeleteTask
  userCantDeleteTaskReason
  hasChildren
  sageIntacctId
  name
  favoured
  highPriority
  bug
  blocked
  startDay
  startMonth
  startYear
  deadlineDay
  deadlineMonth
  jiraId
  vstsId
  deadlineYear
  subTaskCount
  fileCount
  commentCount
  done
  parentTaskId
  hasInvoicedTime
  role {
    id
    name
  }
  parentTask {
    name
    id
  }
  statusColumnV2 {
    id
    category
    projectGroupStatusColumnId
  }
  taskLabels {
    id
    label {
      id
      name
      color
    }
  }
  coverFile {
    id
    name
    key
  }
  project {
    id
    companyProjectId
    projectColor
    name
    status
    projectStartYear
    projectStartMonth
    projectStartDay
    projectEndYear
    projectEndMonth
    projectEndDay
    projectGroupId
    unit4Project {
      activitiesEnabled
      id
    }
    harvestProject {
      id
    }
    client {
      name
      logoId
      logoDefaultId
      id
    }
    isProgramRevenueLocked
    programBudgetType
    ...DeprecatedProjectIndicatorJS_project
  }
  thisTaskDependsOn(first: 1000) {
    edges {
      node {
        id
        type
        thisDependsOnTask {
          statusColumnV2 {
            category
            id
          }
          id
        }
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  dependsOnThisTask(first: 1000) {
    edges {
      node {
        id
        type
        taskDependsOnThis {
          id
          statusColumnV2 {
            category
            id
          }
        }
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  assignedPersons {
    id
    firstName
    lastName
    fullName
    email
    profilePictureId
    profilePictureDefaultId
    active
    permissions
    role {
      id
      name
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateTaskInput!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "favoured",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "favouredSortOrder",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedTasksIds",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "favouredTasksCount",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "Role",
  "kind": "LinkedField",
  "name": "role",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v7/*: any*/)
  ],
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "category",
  "storageKey": null
},
v10 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000
  }
],
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "StatusColumnV2",
  "kind": "LinkedField",
  "name": "statusColumnV2",
  "plural": false,
  "selections": [
    (v9/*: any*/),
    (v2/*: any*/)
  ],
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "favoriteTaskMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateTaskPayload",
        "kind": "LinkedField",
        "name": "updateTask",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TaskTypeEdge",
            "kind": "LinkedField",
            "name": "taskEdge",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Task",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "DraggableCard_task"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Viewer",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": [
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "favoriteTaskMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateTaskPayload",
        "kind": "LinkedField",
        "name": "updateTask",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TaskTypeEdge",
            "kind": "LinkedField",
            "name": "taskEdge",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Task",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "billable",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "latestUiUpdateAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "description",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "timeLeft",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "progress",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "estimateForecastMinutes",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalMinutesRegistered",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "companyTaskId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TaskReadOnly",
                    "kind": "LinkedField",
                    "name": "readOnly",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isReadOnly",
                        "storageKey": null
                      },
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "userCanDeleteTask",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "userCantDeleteTaskReason",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasChildren",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "sageIntacctId",
                    "storageKey": null
                  },
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "highPriority",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "bug",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "blocked",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "startDay",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "startMonth",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "startYear",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "deadlineDay",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "deadlineMonth",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "jiraId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "vstsId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "deadlineYear",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "subTaskCount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "fileCount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "commentCount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "done",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "parentTaskId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasInvoicedTime",
                    "storageKey": null
                  },
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Task",
                    "kind": "LinkedField",
                    "name": "parentTask",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "StatusColumnV2",
                    "kind": "LinkedField",
                    "name": "statusColumnV2",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v9/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "projectGroupStatusColumnId",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TaskLabel",
                    "kind": "LinkedField",
                    "name": "taskLabels",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Label",
                        "kind": "LinkedField",
                        "name": "label",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v7/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "color",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "File",
                    "kind": "LinkedField",
                    "name": "coverFile",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v7/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "key",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectType",
                    "kind": "LinkedField",
                    "name": "project",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "companyProjectId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "projectColor",
                        "storageKey": null
                      },
                      (v7/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "status",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "projectStartYear",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "projectStartMonth",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "projectStartDay",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "projectEndYear",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "projectEndMonth",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "projectEndDay",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "projectGroupId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Unit4ProjectType",
                        "kind": "LinkedField",
                        "name": "unit4Project",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "activitiesEnabled",
                            "storageKey": null
                          },
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "HarvestProjectType",
                        "kind": "LinkedField",
                        "name": "harvestProject",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Client",
                        "kind": "LinkedField",
                        "name": "client",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "logoId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "logoDefaultId",
                            "storageKey": null
                          },
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isProgramRevenueLocked",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "programBudgetType",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "customProjectId",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": (v10/*: any*/),
                    "concreteType": "DependencyTypeConnection",
                    "kind": "LinkedField",
                    "name": "thisTaskDependsOn",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "DependencyTypeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "DependencyType",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v11/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Task",
                                "kind": "LinkedField",
                                "name": "thisDependsOnTask",
                                "plural": false,
                                "selections": [
                                  (v12/*: any*/),
                                  (v2/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v13/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v14/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v15/*: any*/)
                    ],
                    "storageKey": "thisTaskDependsOn(first:1000)"
                  },
                  {
                    "alias": null,
                    "args": (v10/*: any*/),
                    "filters": null,
                    "handle": "connection",
                    "key": "Task_thisTaskDependsOn",
                    "kind": "LinkedHandle",
                    "name": "thisTaskDependsOn"
                  },
                  {
                    "alias": null,
                    "args": (v10/*: any*/),
                    "concreteType": "DependencyTypeConnection",
                    "kind": "LinkedField",
                    "name": "dependsOnThisTask",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "DependencyTypeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "DependencyType",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v11/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Task",
                                "kind": "LinkedField",
                                "name": "taskDependsOnThis",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  (v12/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v13/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v14/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v15/*: any*/)
                    ],
                    "storageKey": "dependsOnThisTask(first:1000)"
                  },
                  {
                    "alias": null,
                    "args": (v10/*: any*/),
                    "filters": null,
                    "handle": "connection",
                    "key": "Task_dependsOnThisTask",
                    "kind": "LinkedHandle",
                    "name": "dependsOnThisTask"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Person",
                    "kind": "LinkedField",
                    "name": "assignedPersons",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "firstName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "lastName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "fullName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "email",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "profilePictureId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "profilePictureDefaultId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "active",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "permissions",
                        "storageKey": null
                      },
                      (v8/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Viewer",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "favoriteTaskMutation",
    "operationKind": "mutation",
    "text": "mutation favoriteTaskMutation(\n  $input: UpdateTaskInput!\n) {\n  updateTask(input: $input) {\n    taskEdge {\n      node {\n        id\n        favoured\n        favouredSortOrder\n        ...DraggableCard_task\n      }\n    }\n    updatedTasksIds\n    viewer {\n      favouredTasksCount\n      id\n    }\n  }\n}\n\nfragment DeprecatedProjectIndicatorJS_project on ProjectType {\n  name\n  companyProjectId\n  customProjectId\n  projectColor\n}\n\nfragment DraggableCard_task on Task {\n  id\n  billable\n  latestUiUpdateAt\n  description\n  timeLeft\n  progress\n  favouredSortOrder\n  estimateForecastMinutes\n  totalMinutesRegistered\n  companyTaskId\n  readOnly {\n    isReadOnly\n    id\n  }\n  userCanDeleteTask\n  userCantDeleteTaskReason\n  hasChildren\n  sageIntacctId\n  name\n  favoured\n  highPriority\n  bug\n  blocked\n  startDay\n  startMonth\n  startYear\n  deadlineDay\n  deadlineMonth\n  jiraId\n  vstsId\n  deadlineYear\n  subTaskCount\n  fileCount\n  commentCount\n  done\n  parentTaskId\n  hasInvoicedTime\n  role {\n    id\n    name\n  }\n  parentTask {\n    name\n    id\n  }\n  statusColumnV2 {\n    id\n    category\n    projectGroupStatusColumnId\n  }\n  taskLabels {\n    id\n    label {\n      id\n      name\n      color\n    }\n  }\n  coverFile {\n    id\n    name\n    key\n  }\n  project {\n    id\n    companyProjectId\n    projectColor\n    name\n    status\n    projectStartYear\n    projectStartMonth\n    projectStartDay\n    projectEndYear\n    projectEndMonth\n    projectEndDay\n    projectGroupId\n    unit4Project {\n      activitiesEnabled\n      id\n    }\n    harvestProject {\n      id\n    }\n    client {\n      name\n      logoId\n      logoDefaultId\n      id\n    }\n    isProgramRevenueLocked\n    programBudgetType\n    ...DeprecatedProjectIndicatorJS_project\n  }\n  thisTaskDependsOn(first: 1000) {\n    edges {\n      node {\n        id\n        type\n        thisDependsOnTask {\n          statusColumnV2 {\n            category\n            id\n          }\n          id\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  dependsOnThisTask(first: 1000) {\n    edges {\n      node {\n        id\n        type\n        taskDependsOnThis {\n          id\n          statusColumnV2 {\n            category\n            id\n          }\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  assignedPersons {\n    id\n    firstName\n    lastName\n    fullName\n    email\n    profilePictureId\n    profilePictureDefaultId\n    active\n    permissions\n    role {\n      id\n      name\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = 'c80083be568f0daafd7c65734e1a7ed5';
export default node;
